var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import merge from "lodash.merge";
import { rem } from "polished";
export function createTypography(typography = {}) {
    const { baseFontSize = 16, baseLineHeight = 1.5, baseLetterSpacing = 0, fontFamilies: { base = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, sans-serif", heading = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, sans-serif", mono = "'SF Mono', 'Segoe UI Mono', 'Roboto Mono', Menlo, Courier, monospace", } = {}, fontWeights: { light = 300, regular = 400, medium = 500, semiBold = 600, bold = 700 } = {}, h1, h2, h3, h4, h5, h6, body, small, label } = typography, typographyOverride = __rest(typography, ["baseFontSize", "baseLineHeight", "baseLetterSpacing", "fontFamilies", "fontWeights", "h1", "h2", "h3", "h4", "h5", "h6", "body", "small", "label"]);
    function setTypography({ fontFamily = base, fontSize = baseFontSize, fontWeight = regular, lineHeight = baseLineHeight, letterSpacing = baseLetterSpacing, }) {
        return {
            fontFamily,
            fontSize: rem(fontSize),
            fontWeight,
            lineHeight,
            letterSpacing,
        };
    }
    const elements = {
        h1: setTypography(Object.assign({ fontFamily: heading, fontSize: 32, fontWeight: light }, h1)),
        h2: setTypography(Object.assign({ fontFamily: heading, fontSize: 28, fontWeight: light }, h2)),
        h3: setTypography(Object.assign({ fontFamily: heading, fontSize: 24 }, h3)),
        h4: setTypography(Object.assign({ fontFamily: heading, fontSize: 20 }, h4)),
        h5: setTypography(Object.assign({ fontFamily: heading, fontSize: 16 }, h5)),
        h6: setTypography(Object.assign({ fontFamily: heading, fontSize: 12 }, h6)),
        body: setTypography(Object.assign({}, body)),
        small: setTypography(Object.assign({ fontSize: 14, lineHeight: 1.75 }, small)),
        label: setTypography(Object.assign({ fontSize: 12, lineHeight: 1.66 }, label)),
        code: setTypography({ fontFamily: mono }),
    };
    return merge({
        typography: Object.assign({ baseFontSize,
            baseLineHeight,
            baseLetterSpacing, fontFamilies: { base, heading, mono }, fontWeights: { light, regular, medium, semiBold, bold } }, elements),
    }, typographyOverride);
}
export default createTypography;
//# sourceMappingURL=create-typography.js.map